import { render, staticRenderFns } from "./wltjfx.vue?vue&type=template&id=38725e5f&"
import script from "./wltjfx.vue?vue&type=script&lang=js&"
export * from "./wltjfx.vue?vue&type=script&lang=js&"
import style0 from "./wltjfx.vue?vue&type=style&index=0&id=38725e5f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports